import React from 'react';
import './SkintypeThumb.css';

function SkinThumb({
  width = 320,
  height = 281,
  image,
  description,
  onClick = () => {}
}) {
  return (
    <div
      style={{ width: width + 'px', height: height + 'px' }}
      className="skinThumb"
      onClick={onClick}
    >
      <img src={image} alt="a face" style={{ height: height + 'px' }} />
      {description && <div className="skinThumbTextDiv">{description}</div>}
    </div>
  );
}

export default SkinThumb;
